import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './MyProjects.css';
import { Button } from 'react-bootstrap';

const MyProjects = () => {
    const [myprojects, setMyprojects] = useState([]);
    useEffect(() => {
        fetch("https://api.npoint.io/16c9e4824bc263427cec")
            .then((res) => res.json())
            .then((data4) => setMyprojects(data4));
    }, []);
    return (
        <div className="txbg container">
            {/* <hr className="text-center text-white w-75 mx-auto mt-5" /> */}
            <h2 className="myProjectstext">Recent <br /> Projects</h2>

            <div className="d-flex flex-wrap justify-content-between txbg">
                {myprojects.map((myproject) => {
                    return (
                        <div className="col-md-6 my-4 cardStyle " style={{width: "32rem"}} key={myproject.id}>
                           
                            <img src={myproject.ftimg} className="w-100" alt="..." />
                                <div className="card-body">
                                    <h5 className="card-title text-info mt-3">
                                        {myproject.name}
                                    </h5>
                                    <p className="card-text text-white description" style={{height: "100px"}}>{myproject.description}</p>
                                    <div className="mx-auto mb-4">
                                    <Link to={`/projects/${myproject.id}`}>
                                        {" "}
                                        <button className="btnDetails">View Details</button>
                                    </Link>
                                    
                                    <Button className="ms-5 btn btn-warning rounded-pill px-5 py-2" href={`${myproject.live}`} target="_blank">Live Link</Button>
                                </div>
                                
                                </div>
                            </div>
                
                    );
                })}
            </div>
        </div>
    );
};

export default MyProjects;